























































































import { Component, Vue } from "vue-property-decorator";
import AddServisMarkupModal from "./modals/addServisMarkupModal.vue";

// Servis Markup için interface tanımı
interface ServisMarkup {
  id: string;
  service: {
    id: string;
    name: string;
  };
  agency: {
    id: string;
    name: string;
  };
  fromAirportId: string;
  toAirportId: string;
  percentageMarkup: number;
  fixedMarkup: number; 
  currencyId: string;
}

@Component({
  components: { AddServisMarkupModal },
})
export default class ServisMarkupPage extends Vue {
  isOpenModal = false;
  headers: Array<{text: string; value: string}> = [];
  breadcrumbsItems: Array<{text: string; disabled: boolean; href?: string}> = [];
  servisMarkups: ServisMarkup[] = [];

  async getServisMarkups(): Promise<void> {
    await this.$store.dispatch({
      type: "servisMarkup/getServisMarkups"
    });
    
    this.servisMarkups = this.$store.state.servisMarkup.list;
  }

  async created(): Promise<void> {
    await this.getServisMarkups();
    
    this.headers = [
      { text: "Servis", value: "service.name" },
      { text: "Servis Adı", value: "service.name" },
      { text: "Havalimanı", value: "airports" },
      { text: "Yüzde", value: "percentageMarkup" },
      { text: "Fiyat", value: "fixedMarkup" },
      { text: "Para Birimi", value: "currencyId" },
      { text: "İşlemler", value: "actions" },
    ];

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "Servis Markup", disabled: true },
    ];
  }

  openModal(): void {
    this.isOpenModal = true;
  }

  closeModal(): void {
    this.isOpenModal = false;
    this.$store.state.servisMarkup.editAuxiliaryMarkup = null;
    this.getServisMarkups();
  }

  editServisMarkup(item: ServisMarkup): void {
    this.$store.state.servisMarkup.editAuxiliaryMarkup = item;
    this.isOpenModal = true;
  }

  async deleteServisMarkup(item: ServisMarkup): Promise<void> {
    try {
      await this.$store.dispatch({
        type: "servisMarkup/deleteServisMarkup",
        payload: item.id,
      });
      await this.getServisMarkups();
    } catch (error) {
      console.error("Silme işlemi sırasında hata:", error);
    }
  }

  confirmDelete(item: ServisMarkup): void {
    this.$swal({
      title: "Satır Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning", 
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteServisMarkup(item);
        Vue.$toast.success("Silme Başarılı");
      }
    });
  }

  get groupedServisMarkups() {
    return this.servisMarkups
      .map(item => ({
        ...item,
        agency: {
          ...item.agency,
          name: item.agency.name.trim().toUpperCase()
        }
      }))
      .sort((a, b) => {
        // Önce agency name'e göre sırala
        const agencyCompare = a.agency.name.localeCompare(b.agency.name);
        if (agencyCompare !== 0) return agencyCompare;
        
        // Aynı agency içindeki servisleri servis adına göre sırala
        return a.service.name.localeCompare(b.service.name);
      });
  }

  get groupByAgency(): string {
    return "agency.name";
  }
}
